import { render } from "./CarCorrectionPage.vue?vue&type=template&id=47c581e6"
import script from "./CarCorrectionPage.vue?vue&type=script&lang=js"
export * from "./CarCorrectionPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__